export var EHeroSlideType;
(function (EHeroSlideType) {
    EHeroSlideType["DAILY_BOOST"] = "daily_boost";
})(EHeroSlideType || (EHeroSlideType = {}));
export var heroDiscoveriesSliceName = 'heroSlice';
export var EHeroLogType;
(function (EHeroLogType) {
    EHeroLogType[EHeroLogType["VIEW"] = 0] = "VIEW";
    EHeroLogType[EHeroLogType["CLICKED"] = 1] = "CLICKED";
    EHeroLogType[EHeroLogType["DISMISSED"] = 2] = "DISMISSED";
})(EHeroLogType || (EHeroLogType = {}));
